const StatusBadge = ({ active }) => (
    <span
        className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-semibold border
            ${
                active
                    ? "text-blue-600 border-blue-600 bg-blue-50"
                    : "text-gray-500 border-gray-400 bg-gray-100"
            }`}
    >
        {active ? "Activo" : "Inactivo"}
    </span>
);

export default StatusBadge;